import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import AiToolTemplateV2 from '../../AiToolTemplate/AiToolTemplateV2';
import { createComponentConfig, createComponentItem, COMPONENT_TYPES, PROMPT_STRATEGIES, TOOL_IDS } from '../../AiToolTemplate/config/componentConfig';

const WeddingPhoto = () => {
  const { t } = useI18n();

  const config = createComponentConfig({
    toolName: t('aiWorkbench.tools.weddingPhoto.title') || '婚紗照',
    toolIcon: '💍',
    toolDescription: t('aiWorkbench.tools.weddingPhoto.description') || t('aiWorkbench.tools.weddingPhoto.ui.promptDescription'),
    gradientColors: ['#ff99cc', '#ffd1e8'],
    apiEndpoint: '/generate-image/edit',
    apiParams: {},
    components: [
      createComponentItem({
        id: 'photos',
        type: COMPONENT_TYPES.IMAGE_UPLOAD,
        title: t('aiWorkbench.tools.weddingPhoto.ui.uploadTitle'),
        description: t('aiWorkbench.tools.weddingPhoto.ui.uploadDescription', { max: 2 }),
        required: true,
        props: { multiple: true, preview: true, gridItemHeight: 100, maxFiles: 2, uploadAreaHeight: 100 },
        promptKey: 'images',
        order: 1
      }),
      createComponentItem({
        id: 'size',
        type: COMPONENT_TYPES.SIZE_SELECTOR,
        title: t('aiWorkbench.aspectRatio'),
        required: true,
        defaultValue: 'Auto',
        order: 2
      }),
      createComponentItem({
        id: 'weddingTheme',
        type: COMPONENT_TYPES.TAG_SELECTOR,
        required: false,
        props: {
          dictName: 'weddingPhotoWeddingTheme',
          allowMultiple: false
        },
        order: 3
      }),
      createComponentItem({
        id: 'outfitStyles',
        type: COMPONENT_TYPES.TAG_SELECTOR,
        required: false,
        props: {
          dictName: 'weddingPhotoOutfitStyles',
          allowMultiple: false
        },
        order: 4
      }),
      createComponentItem({
        id: 'poseInteraction',
        type: COMPONENT_TYPES.TAG_SELECTOR,
        required: false,
        props: {
          dictName: 'weddingPhotoPoseInteraction',
          allowMultiple: false
        },
        order: 5
      }),
      createComponentItem({
        id: 'technicalGuardrails',
        type: COMPONENT_TYPES.TAG_SELECTOR,
        required: false,
        props: {
          dictName: 'weddingPhotoTechnicalGuardrails',
          allowMultiple: false
        },
        order: 6
      }),
      createComponentItem({
        id: 'extraPrompt',
        type: COMPONENT_TYPES.PROMPT_INPUT,
        title: t('aiWorkbench.tools.weddingPhoto.ui.promptTitle'),
        description: t('aiWorkbench.tools.weddingPhoto.ui.promptDescription'),
        required: false,
        props: { placeholder: t('aiWorkbench.tools.weddingPhoto.ui.promptPlaceholder') },
        promptKey: 'prompt',
        order: 7
      }),
    ],
    promptConfig: {
      strategy: PROMPT_STRATEGIES.CUSTOM,
      customHandler: (values) => {
        return values.extraPrompt;
      }
    },
    additionalParams: {
      width: 1024,
      height: 1024,
      model: 'nano',
      steps: 30,
      cfgScale: 8.5,
      strength: 0.45, // Lower strength to preserve more original face features
      imageStrength: 0.8 // High image strength for identity preservation
    },
    layout: 'default'
  });

  return (
    <AiToolTemplateV2
      toolName={config.toolName}
      toolIcon={config.toolIcon}
      toolDescription={config.toolDescription}
      config={config}
      gradientColors={config.gradientColors}
      toolId={TOOL_IDS.WEDDING_PHOTO}
    />
  );
};

export default WeddingPhoto;
